export default __webpack_public_path__ + "static/media/search-interest.64420227.gif";